export default "__VITE_ASSET__DEvDK4a3__"